function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clothes-2_svg__id-2a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32 216.725C32 185.397 59.187 160 92.723 160h46.554C172.813 160 200 185.397 200 216.725V232H32v-15.275z",
  fill: "#FFA0EA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M164 165c20.495 2.277 36 19.601 36 40.222V241h-36v-76zm-96 0c-20.495 2.277-36 19.601-36 40.222V241h36v-76z",
  fill: "#FF4794"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.716 213.476L140 160H92l24.021 53.585c.729 1.627 3.062 1.559 3.695-.109z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clothes-2_svg__id-2a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h232v232H0z"
})));

function SvgClothes2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/media/clothes-2.8b28a238.svg";
export { SvgClothes2 as ReactComponent };